module.exports = __webpack_public_path__ + "img/xr_qled.b699b6b5.jpg";